import { render, staticRenderFns } from "./SettingCard.vue?vue&type=template&id=281430c3"
import script from "./SettingCard.vue?vue&type=script&lang=js"
export * from "./SettingCard.vue?vue&type=script&lang=js"
import style0 from "./SettingCard.vue?vue&type=style&index=0&id=281430c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports